import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import localeText from "../../../../../locale";
import { usePayment } from "../../Checkout/context/PaymentContext";
import PayPalButtonsOnly from "../../../../../components/PayPalCheckoutCart/PayPalButtonsOnly";

const SinglePaymentPayPal = ({ currencyProduct, currencyFormat, combinePayment, totalPrice }) => {
  const toast = useRef(null);
  const {
    selectedPaymentMethod,
    calculateRemainingPrice,
    address,
    city,
    country,
    district,
    number,
    postalCode,
    state,
    amountWallet,
    amountToPayWithExtracredit,
    amountToPayWithCreditCard,
    amountBankTransfer,
    bankTransferReceipt,
    isPaymentMethodAvailable,
    isTotalCovered,
    isPaymentMethodInUse,
    loading,
    setLoading,
    setAmountExtracredit,
    setAmountWallet,
    setAmountBankTransfer,
    setBankTransferReceipt,
    setAmountCreditCard,
  } = usePayment();

  useEffect(() => {
    if (!combinePayment && selectedPaymentMethod === "paypal") {
      setAmountExtracredit(0);
      setAmountWallet(0);
      setAmountBankTransfer(0);
      setBankTransferReceipt(null);
      setAmountCreditCard(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPaymentMethod, combinePayment]);

  const remainingPrice = calculateRemainingPrice();
  const isAvailable = isPaymentMethodAvailable("paypal");
  const totalCovered = isTotalCovered();
  const isInUse = isPaymentMethodInUse("paypal");

  const priceToUse = combinePayment
    ? remainingPrice
    : parseFloat((Number(totalPrice) || 0).toFixed(2));

  if (combinePayment && totalCovered && !isInUse && !loading) {
    return (
      <div className="flex flex-column gap-2">
        <div className="p-3 bg-blue-50 border-round border-blue-200">
          <div className="flex align-items-center gap-2">
            <i className="pi pi-info-circle text-blue-600"></i>
            <span className="text-blue-800 font-medium">{localeText("totalAlreadyCovered")}</span>
          </div>
          <small className="text-blue-700 mt-1 block">
            {localeText("paymentCompleteWithOtherMethodsExplanation")}
          </small>
        </div>
      </div>
    );
  }

  if (combinePayment && !isAvailable && !loading) {
    return (
      <div className="flex flex-column gap-2">
        <div className="p-3 bg-gray-50 border-round border-gray-200">
          <div className="flex align-items-center gap-2">
            <i className="pi pi-ban text-gray-600"></i>
            <span className="text-blue-800 font-medium">{localeText("methodNotAvailable")}</span>
          </div>
          <small className="text-blue-700 mt-1 block">
            {localeText("methodNotAvailableExplanation")}
          </small>
        </div>
      </div>
    );
  }

  const finalPrice = priceToUse && priceToUse > 0 ? priceToUse : 0;

  return (
    <>
      <Toast ref={toast} />
      <PayPalButtonsOnly
        userCurrency={currencyProduct}
        price={finalPrice}
        loading={loading}
        setLoading={setLoading}
        addressInfo={{
          address: address || "",
          city: city || "",
          country: country || "",
          district: district || "",
          number: number || "",
          postalCode: postalCode || "",
          state: state || "",
        }}
        amountWallet={amountWallet || 0}
        priceOriginal={finalPrice}
        toast={toast}
        amountToPayWithExtracredit={amountToPayWithExtracredit || 0}
        amountToPayWithCreditCard={amountToPayWithCreditCard || 0}
        amountBankTransfer={amountBankTransfer || 0}
        bankTransferReceipt={bankTransferReceipt}
        setDisplayPaymentModal={() => {}}
        setIdTransaction={() => {}}
        creditCardData={null}
        disabled={false}
      />
    </>
  );
};

export default SinglePaymentPayPal;
